// Drilled-from-pivot chip — persists until operator clears it.
// Survives the 4s toast TTL so a missed undo click isn't fatal.
// Extracted from DataSurfaceV3 during the agent-velocity refactor.

import * as React from 'react';
import type { FilterRow } from '../v2/recipe-sql';

export type DrillbackState = {
  field: string;
  value: string;
  prevFilters: FilterRow[];
};

export function DrillbackChip({
  state,
  setFilters,
  setGroupByField,
  setDrillback,
}: {
  state: DrillbackState | null;
  setFilters: React.Dispatch<React.SetStateAction<FilterRow[]>>;
  setGroupByField: (field: string | null) => void;
  setDrillback: (state: DrillbackState | null) => void;
}): React.ReactElement | null {
  if (!state) return null;
  return (
    <div style={{
      display: 'flex', alignItems: 'center', gap: 8,
      padding: '6px 10px',
      background: 'var(--accent-soft)', border: '1px solid var(--accent-line)',
      borderRadius: 6, fontSize: 11.5,
    }}>
      <span style={{ color: 'var(--accent)' }}>
        ↳ Drilled from <code style={{ fontFamily: 'var(--mono)' }}>{state.field}</code> pivot
      </span>
      <span style={{ flex: 1 }} />
      <button
        type="button"
        onClick={() => {
          setFilters(state.prevFilters);
          setGroupByField(state.field);
          setDrillback(null);
        }}
        className="btn sm ghost"
        style={{ padding: '2px 10px', fontSize: 11 }}
        title="Restore the pivot view + previous filters"
      >↶ Back to pivot</button>
      <button
        type="button"
        onClick={() => setDrillback(null)}
        title="Dismiss drill-back chip"
        style={{
          background: 'transparent', border: 'none', cursor: 'pointer',
          color: 'var(--ink-3)', fontSize: 13, padding: '0 6px', lineHeight: 1,
        }}
      >×</button>
    </div>
  );
}
